import SgeDashboardAppService from '../../../../application/platform/sge/dashboard/sge-dashboard-app-service';
import { ACTION_TYPES, useDashboardDispatch } from './dashboard-context';
import { useBaseLayout } from '../../../../components/context/use-base-layout';

export const useDashboardController = () => {
    const { showLoading, showMessage } = useBaseLayout();
    const dispatch = useDashboardDispatch();

    async function loadData() {
        try {
            showLoading({ open: true });
            dispatch({ type: ACTION_TYPES.setLoading, payload: true });
            dispatch({ type: ACTION_TYPES.setError, payload: null });

            const data = await SgeDashboardAppService.getOverview();

            dispatch({ type: ACTION_TYPES.setDashboardData, payload: data });
            dispatch({ type: ACTION_TYPES.setLoading, payload: false });
            showLoading({ open: false });
        } catch (error) {
            showMessage({
                open: true,
                message: 'Não foi possível carregar o painel de controle',
                detail: (error as any).details || (error as Error).message,
                type: 'error'
            });
            dispatch({ type: ACTION_TYPES.setLoading, payload: false });
            dispatch({ type: ACTION_TYPES.setError, payload: 'Erro ao carregar dados do dashboard' });
            showLoading({ open: false });
        }
    }

    return { loadData };
};
